
$('.text-with-cta a.link-button.expand').click(function(e) {
    e.preventDefault();

    var $expandArea = $(this).parents('.text-with-cta').find('.expand-area');
    $expandArea.slideDown();
    $('html, body').animate({
        scrollTop: $(this).parents('.text-with-cta').find('.expand-area').offset().top
    })
});